// extracted by mini-css-extract-plugin
module.exports = {"title":"style_title__wMfIH","contactConfirmationForm":"style_contactConfirmationForm__mviHh","spinning":"style_spinning__2e3f_"};